import axios from 'axios';
import config from '@/../config';
import { oktaAuth } from './auth'; 


const client = axios.create({
    baseURL: config.apiUrl,
    timeout: 60000,
})

const isDev = process.env.NODE_ENV === 'development';

client.interceptors.request.use(async (reqConfig) => {
    if(isDev) return reqConfig;

    try {
        // OktaAuth will auto-renew silently in prod, or just return current token in localhost
      
        const accessToken = await oktaAuth.getAccessToken();

        if (accessToken) {
            reqConfig.headers['Authorization'] = `Bearer ${accessToken}`;
        }
    } catch (error) {
        console.error("Failed to get Okta access token:", error);
    }

    return reqConfig;
}, (error) => {
    return Promise.reject(error);
});

const get = async function(uri) {
    let errors;
    let response;
    try {
        if(!isDev)
            response = await client.get('/proxy/secured' + uri);
        else 
            response = await client.get('/proxy' + uri);
            
        } catch(error) {
        errors = processSaveErrors(error.response.data.errors);
    }

    return errors ?? response?.data;
}

const patch = async function(uri, saveObject) {
    var result = {
        success: false,
        errors: null, 
        id: saveObject.id
    }; 

    try {
         if(!isDev)
           await client.patch('/proxy/secured' + uri, saveObject);
        else 
           await client.patch('/proxy' + uri, saveObject);

    } catch(error) {
        result.errors = processSaveErrors(error.response.data.errors);
    }
    
    result.success = !result.errors;

    return result;
}

const post = async function(uri, saveObject) {
    var result = {
        success: false,
        errors: null, 
        id: null,
        data: null
    }; 
    let response;

    try {
          if(!isDev)
                   response = await client.post('/proxy/secured' + uri, saveObject);
        else 
            response = await client.post('/proxy' + uri, saveObject);
    } catch(error) {
        result.errors = processSaveErrors(error.response.data.errors);
    }
    
    result.success = !result.errors;
    if(response?.data) {
        result.data = response.data;
        if(response.data.id)
            result.id = response.data.id;
    }

    return result;
}

// Can't use 'delete' because it's a protected keyword
const remove = async function(uri) {
    var result = {
        success: false,
        errors: null
    };

    try {
        if (!isDev)
        await client.delete('/proxy/secured' + uri);
        else 
            await client.delete('/proxy' + uri);

    } catch(error) {
        result.errors = processSaveErrors(error.response.data.errors);
    }
        
    result.success = !result.errors;

    return result;
}

const processSaveErrors = function (errors) {
    if(typeof(errors) === "string")
        return [errors];

    var retErrors = []
    for (var key in errors) {
        if (Object.prototype.hasOwnProperty.call(errors, key)) {
            var val = errors[key];
            for(var j = 0; j < val.length; j++)
            {
                retErrors.push(key + ' ' + val[j]);
            }
        }
    }
    return retErrors;
}

export const apiClient = {
    get,
    post,
    patch,
    remove
}